import React from 'react';
import {NumericFormat} from 'react-number-format';

export default function SumInput({value, onChange, placeholder = "", isValid = true}) {
    return (
        <NumericFormat
            value={value}
            thousandSeparator={true}
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            placeholder={placeholder}
            onValueChange={(values) => {
                onChange(values.value); // numeric string without formatting
            }}
            className={`sum-input ${!isValid ? 'invalid-input' : ''}`}
            type="text"
        />
    );
}
